module.exports = __webpack_public_path__ + "img/Logins@.831d77cb.svg";